export default __webpack_public_path__ + "static/media/about_trees_logo.5a2b6dd4.png";